import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { identify, groupOrganization, registerGlobals, pageview } from '@/services/posthogService'
import type { RootState } from '@/store'

const getAuthUser = (state: RootState) => state.auth?.user

export default function PostHogInitializer() {
  const location = useLocation()
  const user = useSelector(getAuthUser)

  // PostHog is initialized by PostHogProvider in main.tsx

  useEffect(() => {
    if (!user?.id) {
      return
    }

    identify(String(user.id), {
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      role: user.role,
    })

    const organizationName = localStorage.getItem('ORGANIZATION_NAME')
    const plan = localStorage.getItem('PLAN')

    if (user.client_id) {
      groupOrganization(String(user.client_id), {
        name: organizationName,
        plan,
      })
    }

    registerGlobals({
      organization_id: user.client_id ? String(user.client_id) : undefined,
      user_role: user.role,
    })
  }, [user?.id, user?.client_id, user?.email, user?.first_name, user?.last_name, user?.role])

  useEffect(() => {
    const url = location.pathname + location.search
    pageview(url)
  }, [location.pathname, location.search])

  return null
}
